import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { GrnLine, GrnLineCreate, GrnLineFilter } from '../data/grnLine';

export function createGrnLineService(client: AxiosInstance) {
  return createCrudService<GrnLine, GrnLineCreate, GrnLineFilter>(
    client,
    '/purchase/GrnLine',
    'id',
  );
}

export type GrnLineService = CrudService<GrnLine, GrnLineCreate, GrnLineFilter>;
